export const SILENT_AUDIO = "SILENT_AUDIO";
export const AUDIO = "AUDIO";
export const DASH_LEGACY = "DASH_LEGACY";
export const HLS_LOOP_LEGACY = "HLS_LOOP_LEGACY";
export const HLS_DESKTOP_LEGACY = "HLS_DESKTOP_LEGACY";
export const MP4_HIGH = "MP4_HIGH";
export const MP4_LOW = "MP4_LOW";
export const MP4_MEDIUM = "MP4_MEDIUM";
export const MP4_VERY_HIGH = "MP4_VERY_HIGH";
export const DASH = "DASH";
export const DASH_FALLBACK = "DASH_FALLBACK";
export const HLS = "HLS";
